import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import RecoverSpinStartState from "../../../vendor_core/src/states/RecoverSpinStartState";
import BURCascadeReelGroup from "../../src/view/BURCascadeReelGroup";
import BURReelsModel from "../models/BURReelsModel";

export default class BURRecoverSpinStartState extends RecoverSpinStartState {
    startSpin() {
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as BURCascadeReelGroup;
        reelGroup.disableSwipeSpin();
        super.initReel();
        BURReelsModel.reels.once(GameEvents.ALL_REELS_STARTED, () => {
            this.skipRequest();
        });
        // SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, true, 1);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);
    }

    skipRequest() {
        if (!SpinModel.isInFreespins()) {
            UIController.updateFields(UIUpdateEvent.Balance);
            SpinModel.spinFinished = false;
        }
        this.exit();
    }
}
